export default class Accordion {
    constructor(
        accordionElement,
        btnClass = "jsAccordionBtn",
        contentClass = "jsAccordionContent",
        accordionOpenOnInit = false
    ) {
        this.accordion = accordionElement;
        this.currentTab = null;
        this.accordionOpenOnInit = accordionOpenOnInit;
        this.accordionClosed = false;
        this.accordionActive = false;
        this.btnClass = btnClass;
        this.contentClass = contentClass;

        if (this.accordion) {
            this.accordionBtns = Array.from(
                this.accordion.getElementsByClassName(this.btnClass)
            );
            this.accordionContents = Array.from(
                this.accordion.getElementsByClassName(this.contentClass)
            );

            if (this.accordionBtns.length && this.accordionContents.length) {
                this.events();
            }
        }
    }

    events() {
        this.prepareAccordion();

        window.addEventListener(
            "resize",
            this.maintainContentHeight.bind(this)
        );

        this.accordion.addEventListener(
            "click",
            this.handleAccordionClick.bind(this)
        );
    }

    prepareAccordion() {
        this.accordionBtns.forEach((btn, idx) => {
            btn.classList.remove("is-hidden");
            btn.removeAttribute("aria-hidden");

            if (this.accordionOpenOnInit) {
                btn.setAttribute("aria-expanded", "true");
            } else {
                btn.setAttribute("aria-expanded", "false");
            }
        });

        this.accordionContents.forEach((content, idx) => {
            if (this.accordionOpenOnInit) {
                content.setAttribute("aria-hidden", "false");
                const height = content.scrollHeight;
                content.style.height = height + "px";
            } else {
                content.setAttribute("aria-hidden", "true");
                content.style.height = 0;
            }
        });

        this.currentTab = null;
        this.accordionClosed = true;
        this.accordionActive = true;
    }

    maintainContentHeight() {
        if (!this.accordionActive || this.accordionClosed) return;

        const innerHeight =
            this.currentTab.firstElementChild.getBoundingClientRect().height;
        this.currentTab.style.height = innerHeight + "px";
    }

    closeAllItems() {
        this.accordionBtns.forEach((btn) =>
            btn.setAttribute("aria-expanded", "false")
        );

        this.accordionContents.forEach((content) => {
            content.setAttribute("aria-hidden", "true");
            content.style.height = 0;
        });

        this.accordionClosed = true;
    }

    handleAccordionClick(e) {
        const clickedElement = e.target.closest(`.${this.btnClass}`);

        if (!clickedElement) {
            return;
        }

        const itemToOpen = clickedElement.nextElementSibling;

        const height = itemToOpen.scrollHeight;

        if (
            itemToOpen.style.height === "0px" ||
            itemToOpen.style.height === ""
        ) {
            this.closeAllItems();
            itemToOpen.style.height = height + "px";
            clickedElement.setAttribute("aria-expanded", "true");
            itemToOpen.setAttribute("aria-hidden", "false");
            this.currentTab = itemToOpen;
            this.accordionClosed = false;
        } else {
            this.closeAllItems();
        }
    }
}
